module.exports = __webpack_public_path__ + "Flag-36.cbbd039c4daca91c43b629c0c1f86afd.svg";